import UserShortCard from './UserShortCard';

export default UserShortCard;
